export default __webpack_public_path__ + "951fcb1b7648cf75ce82c98f9b494e8b.png";